module.exports = __webpack_public_path__ + "static/media/Roy Aizen.0b0b1fd5.png";